// Re-export the SafeAreaProvider
export { SafeAreaProvider } from 'react-native-safe-area-context';

// Keep the existing zero-inset implementation for web
const useSafeAreaInsets = () => ({ top: 0, bottom: 0, left: 0, right: 0 });

export default useSafeAreaInsets;
